import React, { useState, useEffect } from 'react';
import LoaderSpinner from '../components/LoaderSpinner'

const MyTravelPass = (props) => {
    console.log('test page')
    const [loader, setLoader] = useState(true)
    const profSession = JSON.parse(sessionStorage.getItem('prof-profile'));
    if (!profSession) {
        window.location.href = '/login'
    }
    
    useEffect(() => {
        document.getElementById('myTavelpass').submit();
    }, []);
    const getMarketByHref = () => {
        const href = window.location.href
        if (href.match(/.+\.sas\.se/)) {
            return "se-sv"
        } else if (href.match(/.+\.sas\.no/)) {
            return "no-no"
        } else if (href.match(/.+\.sas\.dk/)) {
            return "dk-da"
        } else if (href.match(/.+\.sas\.fi/)) {
            return "fi-en"
        } else if (href.match(/\/resmal\//)) {
            return "se-sv"
        } else if (href.match(/\/reisemal\//)) {
            return "no-no"
        } else if (href.match(/\/rejsemaal\//)) {
            return "dk-da"
        }
        return getMarketByPathname(href).toLowerCase()
    }

    const isDevEnvironment = () => {
        return (
            window.location.hostname === "localhost" ||
            window.location.hostname.match(/\.local/) ||
            window.location.hostname.match(/^10\..+/)
        )
    }
    const isTestEnvironment = () => {
        return !!window.location.hostname.match(/test\./)
    }
    const market = () => {
        const href = window.location.href
          if (href.match(`\.sas\.se`)) {
            return href.match(`\.test`) ? "https://travelpass.test.sas.se" : "https://travelpass.sas.se"
        } else if (href.match(`\.sas\.no`)) {
          return href.match(`\.test`) ? "https://travelpass.test.sas.no" : "https://travelpass.sas.no"
        } else if (href.match(`\.sas\.dk`)) {
          return href.match(`\.test`) ? "https://travelpass.test.sas.dk" : "https://travelpass.sas.dk"
        } else if (href.match(`\.sas\.fi`)) {
          return href.match(`\.test`) ? "https://travelpass.test.flysas.com" : "https://travelpass.flysas.com"
        } else {
          return  href.match(`\.test`) ||  href.match(`\.local`) ? "https://travelpass.test.flysas.com" : "https://travelpass.test.flysas.com"
        }
      }
    const apiPath = () => {
        return isDevEnvironment() || isTestEnvironment()
            // ? `${market()}/novaOnline/onlineMenu.do`
            // : `${market()}/novaOnline/onlineMenu.do`

            ? "https://travelpasstest.scandinavian.net/novaOnline/onlineMenu.do"
            : "https://travelpass.scandinavian.net/novaOnline/onlineMenu.do"
    }

    const getMarketByPathname = (href) => {
        return (href.match(/\/([a-z]{2}-[a-z]{2})(\/|$).*/i) || [])[1] || "lu-en"
    }
    const getCookie = (name) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop().split(";").shift()
    }
      const travelpassEngagement = () => {
        if (sessionStorage["prof-profile"]) {
        let profileData = JSON.parse(sessionStorage["prof-profile"]);
          let activeTP
          profileData.engagements?.travelPass? profileData.engagements.travelPass.length > 0 ?  profileData.engagements.travelPass.map(item => { if (item.statusCode.toUpperCase() === 'ACTIVE') {  activeTP = item }}) : activeTP = {} : activeTP = {}
          return activeTP.id
            }
      }
    return <>
     <LoaderSpinner loader={loader} />
    <form action={apiPath()} id="myTavelpass" method="post">
                <input type="hidden" name="CHN" value="ECOMM" />
                <input type="hidden" name="POS" value={getMarketByHref().split("-")[0].toUpperCase()} />
                <input type="hidden" name="TPACCOUNT" value={travelpassEngagement()} />
                <input type="hidden" name="SSOTICKET" value={decodeURIComponent(getCookie('NEW_SAS_SSO_LOGGEDIN')).replace('tkt=', '')} /> 
                {/* <input type="hidden" name="SSOTICKET" value={getCookie('NEW_SAS_SSO_LOGGEDIN').replace('tkt=', '').replace('%20', ' ')} /> */}
                <input type="submit" value="Submit" />
    </form>
</>
}
export default MyTravelPass
